<template>
  <div></div>
</template>

<script>
import auth from '../auth'
import { acl_mixin, custom_script_mixin, helper_mixin } from '../mixins'

export default {
  mixins: [acl_mixin, helper_mixin, custom_script_mixin],

  data() {
    return {
      intercom: {
        height: 0
      },
      auth: auth,
    }
  },

  created() {
    // Initialize Intercom if configured
    if (
      !this.hasReporterAccess &&
      this.auth.user &&
      this.auth.user.profile &&
      localStorage.getItem('intercom_app_id') !== ''
    ) {
      this.setupIntercom()
    }

    // Initialize Beamer NPS if configured
    if (
      !this.hasReporterAccess &&
      this.auth.user &&
      this.auth.user.profile &&
      localStorage.getItem('beamer_product_id') !== ''
    ) {
      this.setupBeamerNPS()
    }
  },

  methods: {
    setupIntercom() {
      // Does not allow Intercom in local environments
      if (this.isLocal) {
        return
      }

      axios
        .get('/api/v1/profile/intercom-user-hash')
        .then((res) => {
          // make sure Intercom is loaded
          console.log('[Intercom] Booting ...')
          if (window.Intercom) {
            window.Intercom('boot', {
              alignment: 'left',
              api_base: 'https://api-iam.intercom.io',
              app_id: localStorage.getItem('intercom_app_id'),
              name: this.auth.user.profile.name, // Current user name
              email: this.auth.user.profile.email, // Current user email address
              user_id: this.auth.user.profile.id, // Current user id
              user_hash: res.data, // Current user hash
              created_at: Math.floor(Date.now() / 1000)
            })

            console.log('[Intercom] Boot results:', {
              has_user_id:
                this.auth.user.profile.id !== null &&
                this.auth.user.profile.id !== undefined,
              has_email:
                this.auth.user.profile.email !== null &&
                this.auth.user.profile.email !== undefined,
              has_name:
                this.auth.user.profile.name !== null &&
                this.auth.user.profile.name !== undefined
            })

            window.dispatchEvent(new Event('customResize'))

            // Check if the height of the intercom iframe changes
            // Every second
            let self = this
            setInterval(function () {
              let intercom_iframe = document.querySelector(
                '[name=intercom-banner-frame]'
              )
              let intercom_iframe_height =
                self.getIntercomIframeHeight(intercom_iframe)

              if (intercom_iframe_height !== self.intercom.height) {
                window.dispatchEvent(new Event('customResize'))
              }

              self.intercom.height = intercom_iframe_height
            }, 1 * 1000)
          } else {
            console.log('[Intercom] Not loaded')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    setupBeamerNPS() {
      // Does not allow Beamer NPS in local environments
      if (this.isLocal) {
        return
      }

      console.log('[Beamer NPS] Initializing ...')

      // Update Beamer with user data (script should already be loaded from layout)
      if (window.Beamer) {
        const userData = {
          user_id: this.auth.user.profile.id,
          aloware_org_id: this.auth.user.profile.company_id,
          user_firstname: this.auth.user.profile.first_name,
          user_lastname: this.auth.user.profile.last_name,
          user_email: this.auth.user.profile.email
        }

        window.Beamer.update(userData)
        console.log('[Beamer NPS] User data updated', userData)
      } else {
        console.log('[Beamer NPS] Beamer script or user data not available')
      }
    },
  }
}
</script>
